// components/BuyCreditsDialog.js
import { Dialog, DialogTitle, DialogContent, Button, Stack, Alert } from "@mui/material";
import { useState } from "react";
import { useCredits } from "../context/CreditsContext";

export default function BuyCreditsDialog({ open, onClose }) {
  const { startCheckout } = useCredits();
  const [loading, setLoading] = useState(null);
  const [error, setError]     = useState("");

  const packs = [
    { id: "pack_10k", label: "10 000 credits – $10" },
    { id: "pack_50k", label: "50 000 credits – $45" },
  ];

  const handleBuy = async (packId) => {
    setLoading(packId);
    try {
      await startCheckout(packId);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(null);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Buy Credits</DialogTitle>
      <DialogContent>
        {/* ← NEW: inline error alert */}
        {error && (
          <Alert 
            severity="error" 
            onClose={() => setError("")} 
            sx={{ mb: 2, width: "100%" }}>
            {error}
          </Alert>
        )}

        <Stack spacing={2}>
          {packs.map(p => (
            <Button
              key={p.id}
              variant="contained"
              fullWidth
              disabled={!!loading}
              onClick={() => handleBuy(p.id)}
            >
              {p.label}
            </Button>
          ))}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
